// A retainer or a one-off project — the two kinds of engagement (migration 067). They are
// ONE record on the server (`retainers`, told apart by `billing_mode`), with the same jobs,
// costs, charges, split and profit; only the billing differs. So the screens share their
// components and ask these helpers the one question that separates them.
//
// The server row says `billing_mode`; a money-screen card says `billing`. Both are read.
import he from '../i18n/he';

export const isProject = (r) => !!r && (r.billing_mode === 'fixed' || r.billing === 'fixed');

// Where each kind lives. A project is listed on the one-off projects screen (/jobs) and
// opened at /projects/:id; both detail routes render the same page.
export const engagementPath = (r) => `${isProject(r) ? '/projects' : '/retainers'}/${r.id}`;
export const engagementListPath = (r) => (isProject(r) ? '/jobs' : '/retainers');

// The retainer's words, with the project's layered over them where they differ — so a
// section shared by both reads `t.ownIncome` or `t.deleteScope` and never branches itself.
export const engagementStrings = (r) => (isProject(r)
  ? { ...he.retainers, ...he.projects }
  : he.retainers);
